'use client';

import { Trackable } from '@/components/common';
import { Button } from '@/components/ui';
import { Label } from '@/components/ui/label';
import { formatEventDate } from '@/utils';
import { safeHtmlListParserOptions } from '@/utils/safeHtmlParserOptions';
import parse from 'html-react-parser';
import { Counter } from './components';

interface TProps {
  ticket: any;
  cartData: any;
  eventInfo: any
  handleTicket: (ticketCode: string, quantity: number) => void;
}
const Ticket = ({
  ticket,
  cartData,
  eventInfo,
  handleTicket,
}: TProps) => {
  const {
    eventType,
    eventName,
    eventCode,
    _id: eventId,
  } = eventInfo;

  return (
    <div className='w-full rounded-xl border bg-white p-4 mb-2'>
      <div className='flex items-baseline justify-between gap-2'>
        <Label className='text-lg font-semibold text-wrap'>{ticket?.name}</Label>
        <Label className='text-sm font-semibold text-wrap text-center text-gray-500'>
          {!(ticket?.isSoldOut || ticket?.isComingSoon) &&
            cartData?.selectedDate &&
            formatEventDate(cartData?.selectedDate?.date)}
        </Label>
      </div>

      <div className='mt-2 flex justify-between border-gray-200 pb-2'>
        <Label className='text-xl font-semibold'>
          {eventType === 'FREE_FCFS' || Number(ticket.price) === 0 ? 'FREE' : `₹ ${ticket.price}`}
        </Label>
        {cartData?.selectedTickets?.[ticket.code] ? (
          <Trackable
            eventName='Click'
            eventScope='Change Tickets Count'
            eventProps={{
              'Ticket Code': ticket?.code,
              'Ticket Name': `${ticket?.name}`,
              'Ticket Price': ticket?.price,
              'Event Type': eventType,
              'Event Date': cartData?.selectedDate,
              'Event Name': eventName,
              'Event Code': eventCode,
              'Event Id': eventId,
              'Selected Tickets': cartData?.selectedTickets,
            }}
          >
            <Counter ticket={ticket} handleTicket={handleTicket} />
          </Trackable>
        ) : (
          <Trackable
            eventName='Click'
            eventScope='Add Ticket to Cart'
            eventProps={{
              'Ticket Code': ticket?.code,
              'Ticket Name': `${ticket?.name}`,
              'Ticket Price': ticket?.price,
              'Event Type':  eventType,
              'Event Date':  cartData?.selectedDate,
              'Event Name':  eventName,
              'Event Code':  eventCode,
              'Event Id':  eventId,
              'Selected Tickets': cartData?.selectedTickets,
            }}
          >
            {ticket?.isSoldOut || Number(ticket?.maxSeats) < 1 ? (
              <p className='text-base font-semibold text-red-500'>Sold Out</p>
            ) : ticket?.isComingSoon ? (
              <p className='text-base font-semibold text-gray-500'>
                Coming Soon
              </p>
            ) : (
              <Button
                variant='secondary'
                onClick={() => handleTicket(ticket, 1)}
                className='rounded-lg px-6 py-2 font-bold uppercase'
              >
                Add
              </Button>
            )}
          </Trackable>
        )}
      </div>

      {ticket?.desc && (
        <ul className='mt-1 list-disc border-t pt-2'>
          <li className='flex flex-col gap-2 text-sm font-medium text-gray-500 [&>ul]:list-disc [&>ul]:pl-5'>
            {parse(ticket?.desc, safeHtmlListParserOptions)}
          </li>
        </ul>
      )}
    </div>
  );
};

export default Ticket;
